import { ApiResourceBaseClass as n } from "./baseApiCalls.js";
const e = "review_auto_reply_settings";
class g extends n {
  /**
   * Save auto-reply settings.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/review_auto_reply_settings`
   *
   * @param {ReviewAutoReplySettingsCreateBody} body - The data used to create the auto-reply settings.
   * @returns {Promise<ReviewAutoReplySettings>} A promise resolving to the created auto-reply settings.
   */
  saveSettings = async (t) => {
    const { data: s } = await this.post(e, t);
    return s;
  };
  /**
   * Update auto-reply settings.
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/review_auto_reply_settings/{id}`
   *
   * @param {string} id - The ID of the settings to update.
   * @param {ReviewAutoReplySettingsUpdateBody} body - The data used to update the auto-reply settings.
   * @returns {Promise<ReviewAutoReplySettings>} A promise resolving to the updated auto-reply settings.
   */
  updateSettings = async (t, s) => {
    const { data: a } = await this.put(`${e}/${t}`, s);
    return a;
  };
  /**
   * Get auto-reply settings.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/review_auto_reply_settings`
   *
   * @param {boolean} [forReviewsWithComment] - Whether to get settings for reviews with comments.
   * @returns {Promise<ReceivedReviewAutoReplySettings>} A promise resolving to the received auto-reply settings.
   */
  getSettings = async (t) => {
    const { data: s } = await this.get(e, {
      is_with_content: t ?? !1
    });
    return s;
  };
  /**
   * Toggle auto-reply settings.
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/review_auto_reply_settings/{id}`
   *
   * @param {string} id - The ID of the settings to toggle.
   * @param {boolean} enabled - Whether to enable or disable the settings.
   * @returns {Promise<ReviewAutoReplySettings>} A promise resolving to the toggled auto-reply settings.
   */
  toggleSettings = async (t, s) => await this.updateSettings(t, { enabled: s });
  /**
   * Get business languages for auto-reply settings.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/review_auto_reply_settings/{settingsId}/get_business_languages`
   *
   * @param {string} settingsId - The ID of the settings to get business languages for.
   * @returns {Promise<Record<string, string>>} A promise resolving to the business languages.
   */
  getBusinessesLanguages = async (t) => {
    const { data: s } = await this.get(
      `${e}/${t}/get_business_languages`
    );
    return s;
  };
  /**
   * Get business group IDs for auto-reply settings.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/review_auto_reply_settings/{settingsId}/languages`
   *
   * @param {string} settingsId - The ID of the settings to get business group IDs for.
   * @returns {Promise<BusinessGroupIdsApiResponse>} A promise resolving to the business group IDs.
   */
  getBusinessGroupIds = async (t) => {
    const { data: s } = await this.get(
      `${e}/${t}/languages`
    );
    return s;
  };
  /**
   * Update the title of auto-reply settings.
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/review_auto_reply_settings/{id}`
   *
   * @param {string} id - The ID of the settings to update the title for.
   * @param {string} title - The new title for the settings.
   * @returns {Promise<SuccessResponse>} A promise resolving to the success response of the title update.
   */
  updateSettingTitle = async (t, s) => await this.updateSettings(t, { title: s });
  /**
   * Delete auto-reply settings.
   *
   * HTTP Verb: `DELETE`
   * Endpoint URL: `/review_auto_reply_settings/{settingsId}`
   *
   * @param {string} settingsId - The ID of the settings to delete.
   * @returns {Promise<SuccessResponse>} A promise resolving to the success response of the settings deletion.
   */
  deleteSettings = async (t) => {
    const { data: s } = await this.delete(`${e}/${t}`);
    return s;
  };
}
export {
  g as ReviewAutoReply
};
